var map = {
	"./upgrade1.png": "6758",
	"./upgrade2.png": "fddd",
	"./upgrade3.png": "cbd3",
	"./upgrade4.png": "35b4",
	"./upgrade5.png": "bd04",
	"./upgrade6.png": "3d30",
	"./upgrade7.png": "d654",
	"./upgrade8.png": "9bd7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b6ad";